import { createFileRoute, Link, useRouter } from "@tanstack/react-router";
import { z } from "zod";
import { AuthCard } from "@/components/auth-card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { ResetPasswordForm } from "@/features/auth/reset-password/form";
import { m } from "@/lib/paraglide/messages.js";

// Better Auth checks the emailed link's token, then redirects here with ?token=, or with
// ?error=INVALID_TOKEN when the link was used or has expired (features/auth/forgot-password).
const ResetPasswordSearch = z.object({
  token: z.string().min(1).optional().catch(undefined),
  error: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/(public)/reset-password")({
  validateSearch: ResetPasswordSearch,
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const { token, error } = Route.useSearch();
  const router = useRouter();
  return (
    <AuthCard title={m.reset_title()} footer={<Link to="/forgot-password">{m.reset_request_new_link()}</Link>}>
      {token && !error ? (
        <ResetPasswordForm
          token={token}
          onDone={() => router.navigate({ to: "/login", search: { password: "reset" } })}
        />
      ) : (
        <Alert variant="destructive">
          <AlertDescription>{m.reset_link_expired()}</AlertDescription>
        </Alert>
      )}
    </AuthCard>
  );
}
